module.exports = __webpack_public_path__ + "b8a512cecbe3e1a9f7f1f33751349bac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/fair/banner.png
// module id = ./assets/images/fair/banner.png
// module chunks = 0